import React from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import InputCell from "sheets/components/cells/InputCell"
import { unclickCell } from "sheets/sheet-action-creators"
import { Cell } from "fixed-data-table-2"
import Icon from "app/static/frontend/components/Icon"
import { linkCellConnection } from "sheets/selectors/column-selectors"

// a component to render links in sheets
// in this case, children can be a string, or an array of objects with text and an optional URL.
export const LinkCell = ({ hasMultipleLinks, isValidLink, link, editing, ...props }) => {
    // Wrap the given subLink in an <a /> tag if there is a URL, and separate links with a comma
    const renderSubLink = (subLink, index) => [
        index > 0 && ", ",
        subLink.get("url") ? (
            <a
                className="allow-click"
                href={subLink.get("url")}
                onClick={() => props.unclickCell(props.sheetId)}
                target="_blank"
            >
                {subLink.get("label")} <Icon name="external-link" />
            </a>
        ) : (
            subLink.get("label")
        ),
    ]

    // Render each link individually if there are more than one, or render the single link if it's valid
    const renderLink = () => {
        if (hasMultipleLinks) {
            return link.map(renderSubLink)
        } else if (isValidLink) {
            const linkText = link.includes("quorum.us") ? "Quorum Link " : "External Link "

            return (
                <a className="allow-click" href={link} onClick={() => props.unclickCell(props.sheetId)} target="_blank">
                    {linkText} <Icon name="external-link" />
                </a>
            )
        }

        return "Invalid Link"
    }

    return editing ? <InputCell {...props}>{link}</InputCell> : <Cell {...props}>{link && renderLink()}</Cell>
}

LinkCell.propTypes = {
    editing: PropTypes.bool,
    link: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    hasMultipleLinks: PropTypes.bool.isRequired,
    isValidLink: PropTypes.bool,
    placeholder: PropTypes.string,
    sheetId: PropTypes.string.isRequired,
    unclickCell: PropTypes.func.isRequired,
}

LinkCell.defaultProps = {
    editing: false,
    placeholder: "https://www.quorum.us",
}

export default connect((state, props) => linkCellConnection(state, props), { unclickCell })(LinkCell)
